/**
 * Breadcrumb Component Definitions
 *
 * Constants and utilities for breadcrumb navigation
 */

/**
 * Mobile breakpoint for breadcrumb display
 * Below this width: Show "< Back" button only
 * Above this width: Show full breadcrumb trail
 */
export const BREADCRUMB_MOBILE_BREAKPOINT = 640; // Tailwind 'sm' breakpoint

/**
 * Breadcrumb separator character
 */
export const BREADCRUMB_SEPARATOR = '/';

/**
 * Minimum touch target size (WCAG AAA)
 */
export const MIN_TOUCH_TARGET_SIZE = 44; // pixels

/**
 * CSS classes for breadcrumb styling
 */
export const BREADCRUMB_STYLES = {
  // Container
  container: 'flex items-center gap-2 py-2',
  mobileContainer: 'sm:hidden',
  desktopContainer: 'hidden sm:flex',

  // Navigation
  nav: 'flex items-center',
  list: 'flex items-center gap-2',

  // Items
  item: 'flex items-center',
  link: 'text-blue-600 hover:text-blue-800 hover:underline transition-colors min-h-[44px] flex items-center font-montserrat',
  currentPage: 'text-gray-600 font-montserrat',
  separator: 'text-gray-400 mx-1',

  // Mobile back button
  backButton: 'flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors min-h-[44px] min-w-[44px] font-montserrat',
  backIcon: 'h-5 w-5',
} as const;
